const PaymentType = Object.freeze({
	ONETIME: "one-time",
	WEEKLY: "week",
	MONTHLY: "month",
	QUARTERLY: "quarter",
	YEARLY: "year",
});
export default PaymentType;